// src/mapboxClient.js
import mbxGeocoding from "@mapbox/mapbox-sdk/services/geocoding";

const mapboxClient = mbxGeocoding({
  accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
});

export default mapboxClient;
